import { Component, OnInit } from '@angular/core';
import {Observable, Subscription} from "rxjs/Rx";

import { GoogleApiService } from '../../shared/google-api/google-api.service';
import { LocationService } from '../../locations/location.service';

declare var google: any;

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {

  public activeStyle: any;
  public map: any;
  public marker = new Array();
  public infowindow = new Array();
  public latlngList = new Array();
  public locations: any;
  public geos = new Array();
  public bounds:any;
  public centerSub: Subscription;

  constructor(
		private apiService:GoogleApiService,
    public locationService: LocationService
  ) {}

  ngOnInit() {
    this.activeStyle = null;

    this.centerSub = this.locationService.centers().subscribe((latlng)=>{
      if(latlng === null || latlng.status === "none")
        return;

      let zoom = 4;
      if (this.marker.length > 0) return false;
      this.apiService.loadAPI.then((google: any)=>{
        try {
            this.map = new google.maps.Map(document.getElementById('map-canvas'), {
                center: latlng,
                zoom: zoom,
                mapId: 'dbb277ba3db2bd65',
                disableDefaultUI: true
            });
            this.locationService.locationsSubject.subscribe((dat)=>{
                if(dat === null)
                    return;
                this.setupMap(dat);
            });
        }catch(e) {}
      });
      return;
    });
  }

  ngOnDestroy() {
    if (this.centerSub) this.centerSub.unsubscribe();
  }

  setupMap(dat) {
    this.locations = dat;
    this.bounds = new google.maps.LatLngBounds();
    for(var i = 0; i <= this.locations.length; i++) {
        try {
            var addr = this.locations[i].address1+" "+this.locations[i].city+", "+this.locations[i].prov+" "+this.locations[i].zip;
            this.apiService.getLatLon(addr)
            .subscribe((data)=>{
                if(data.status == "OK") {
                    this.geos.push(data.results);
                    this.setMapPoints(this.geos.length-1);
                }
            });
        }catch(e) {}
    }
  }

  setMapPoints(num) {
    var content = '';
    if (!this.locations[num]) return;
    this.locations[num].devices.forEach((device)=> {
    content += '<a href="/#/admin/devices/details/'+device.id+'">'
            +device.name+
            '</a> '+device.status+' <br>';
    });

    this.infowindow[num] = new google.maps.InfoWindow({
        content: content
    });

    var lat = this.geos[num][0].geometry.location.lat;
    var lon = this.geos[num][0].geometry.location.lng;
    this.latlngList.push(
        new google.maps.LatLng(
            lat,
            lon
        )
    );

    this.marker[num] = new google.maps.Marker({
        position: this.geos[num][0].geometry.location,
        map: this.map,
        title: this.locations[num].company,
        animation: google.maps.Animation.DROP
    });

    this.marker[num].addListener('click', () => {
        this.infowindow[num].open(this.map, this.marker[num]);
    });

    if(num >= this.locations.length-1)
        this.setBounds();
  }

  setBounds() {
    this.latlngList.forEach((i) => {
      this.bounds.extend(i);
    });
    this.map.fitBounds(this.bounds);
    if (this.map.getZoom() > 15) this.map.setZoom(15);
  }

}
